/** The kinds a user can pick a device for. */
export type SelectableDeviceKind = 'camera' | 'microphone' | 'speaker';

/** The slice field holding each kind's device. */
export const DEVICE_SELECTION_FIELD = {
  camera: 'videoDeviceId',
  microphone: 'audioInputDeviceId',
  speaker: 'audioOutputDeviceId',
} as const satisfies Record<SelectableDeviceKind, string>;

// The keys predate the device module; kept so users' existing picks survive.
const STORAGE_KEY: Record<SelectableDeviceKind, string> = {
  camera: 'videoinput-device-selected',
  microphone: 'audioinput-device-selected',
  speaker: 'audiooutput-device-selected',
};

/** The devices the user picked on an earlier visit (or this one), by kind. */
export const readSavedDeviceChoices = (): Record<SelectableDeviceKind, string | null> => ({
  camera: localStorage.getItem(STORAGE_KEY.camera),
  microphone: localStorage.getItem(STORAGE_KEY.microphone),
  speaker: localStorage.getItem(STORAGE_KEY.speaker),
});

export const saveDeviceChoice = (kind: SelectableDeviceKind, deviceId: string): void => {
  localStorage.setItem(STORAGE_KEY[kind], deviceId);
};
